// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2_jAU","colMaxWidth":"Table_colMaxWidth__1rPCT"};